import { put, call } from 'redux-saga/effects';
// import { refreshTokenService } from '../services/refreshTokenService';
import { logoutUserService } from '../services/authenticationService';

import * as types from '../actions';

export function* refreshTokenSaga(payload) {
  try {
    const response = yield call(logoutUserService, payload); 
    //const response = yield call(refreshTokenService, payload); 
    yield put({ type: types.REFRESH_TOKEN_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.REFRESH_TOKEN_ERROR, error })
  }
}